import LiveTipsComponent from "./LiveTipsComponent";

export default LiveTipsComponent;
